/* eslint-disable */
import axios from "axios";
import cytoscape from "cytoscape";
import dagre from "cytoscape-dagre";
import store from "@/store";
import klay from "cytoscape-klay";
import graph from "../../custom_lib/graph_lib/graph.vue";
import graphdiff from "../../custom_lib/graph_lib/graphdiff.vue";
import Multiselect from "@vueform/multiselect";
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import showformmodel from "../showformmodel/showformmodel.vue";
import ChangeSchedulestatus from "../ChangeScheduleStatusPopup/ChangeScheduleStatusPopUp.vue";

cytoscape.use(dagre);
cytoscape.use(klay);

export default {
  name: "NetworkXGraph",
  components: {
    graph,
    graphdiff,
    Multiselect,
    manageVisitModal,
    showformmodel,
    ChangeSchedulestatus
  },

  data() {
    return {
      // version pairs for comparison (left=new, right=old)
      selectedVersionOld: "",
      selectedVersionNew: "",
      showlegends:false,
      // optional single selector still used in UI
      selectedVersion: "",

      graphidentifier: "default",
      customlabel: [{ Nodetype: "Visit", Custlabel: "label" }],

      typeArray: [],
      legendStatus: {},
      difflegendStatus: {},
      popup: { show: false, type: "", x: 0, y: 0 },

      donotcollapse: ["Visit"],
      dictionaryfordetails: {
        FormName: "Form Name",
        FormId: "Form Id",
        FormStatus: "Form Status",
        VisitNo: "Visit No",
        VisitName: "Visit Name",
        VisitType: "Visit Type",
        VisitDate: "Visit Date",
        "Visit Status": "Visit Status"
      },

      setshowFormModal: false,
      collapsedtypes: [],

      // parent-level cy (child graphs manage their own); only used by a few helpers
      cy: null,

      changeStatus: {
        studyId: "",
        visitNo: "",
        subjectNo: "",
        status: ""
      },

      authToken: store.getters.getIdToken,
      rootId: null,
      templatedetails: [],
      selectedgraphid: "",
      selectedLayout: "dagre",
      baseurl: process.env.VUE_APP_Service_URL,

      showNodePopup: false,
      popupPosition: { x: 0, y: 0 },
      selectedNode: null,
      nodeproperties: null,
      detailspopup: false,
      addpropertiespopup: false,
      propname: "",
      propvalue: "",
      creategraphpopup: false,
      newgraphname: "",
      addnodepopup: false,
      subnodename: "",
      addarraypopup: false,
      subnodearrayname: "",
      arrayelementspopup: false,
      arrayelementname: "",

      // IMPORTANT: start with arrays, not {}
      graphdataNew: { nodes: [], links: [] }, // left pane = comparednewstudyversioninfo
      graphdataOld: { nodes: [], links: [] }, // right pane = comparedoldstudyversioninfo

      patients: [],
      selectedpatient: "",
      unscheduledvisitpopup: false,
      menuitems: [
        "expandNode",
        "collapseNode",
        "showproperties",
      ],
      popupdata: {
        studyId: "",
        patientId: "",
        visitNo: "",
        visitName: "Unscheduled Visit",
        visitType: "",
        visitDate: "",
        preVisit: "0",
        postVisit: "0",
        visitStatus: "",
        investigator: "",
        templateId: "",
        templateName: "",
        active: true,
        createdUserEmail: "",
        createdUserId: "",
        lastModifiedUserEmail: "",
        lastModifiedUserId: "",
        IsPatientVisit: false,
        forms: [],
        related: "",
        relationType: "Concurrent",
        visitNote: ""
      },
      selectedTemplateIds: [],
      selectedTemplateModel: [],
      popuperrors: [],
      popupvalidations: [false, false, false, false, false],
      visitList: [],
      users: [],
      sites: [],
      selectedsite: "",
      showSiteModal: false,
      currentvisitid: "0",
      selectedorientation: "LR",
      showChangeSchedule: false,

      // start true so children don't mount with empty data
      spinner: true,
      leftGraphReady: false,
      rightGraphReady: false,

      currentformstatus: "Completed",
      versionList: [],
      currentstudyid: "",
      noversion: false,
      tempoldversion:"",
      tempnewversion:""
    };
  },

  computed: {
    // keys force clean remount when layout/identifier/versions/data-size change
    leftKey() {
      const n = this.graphdataNew?.nodes?.length || 0;
      const e = this.graphdataNew?.links?.length || 0;
      return `graph-left-${this.selectedLayout}-${this.graphidentifier}-${this.selectedVersionOld}-${this.selectedVersionNew}-${n}-${e}`;
    },
    rightKey() {
      const n = this.graphdataOld?.nodes?.length || 0;
      const e = this.graphdataOld?.links?.length || 0;
      return `graph-right-${this.selectedLayout}-${this.graphidentifier}-${this.selectedVersionOld}-${this.selectedVersionNew}-${n}-${e}`;
    },
    isGraphsLoading() {
      return this.spinner || !this.leftGraphReady || !this.rightGraphReady;
    }
  },

  watch: {
     graphdataNew: { handler: 'updateTypeArray', deep: false },
      graphdataOld: { handler: 'updateTypeArray', deep: false },
       selectedVersionOld(newVal, oldVal) {
      this.tempoldversion = oldVal;
    },
    selectedVersionNew(newVal, oldVal) {
      this.tempnewversion = oldVal;
    },
    selectedpatient() {
      if (this.selectedpatient !== "") {
        this.graphidentifier = "selectedpatient";
        this.getcolorcodes();

        const foundObject = this.patients.find(
          (obj) => obj.patientId === this.selectedpatient
        );
        if (foundObject) {
          const gotsitecode = foundObject.siteCode;
          const selectedsiteobj = this.sites.find(
            (obj) => obj.siteCode === gotsitecode
          );
          if (selectedsiteobj) this.selectedsite = selectedsiteobj.siteID;
        }
        this.graphbasedpatient();
      }
    },

    selectedTemplateIds() {
      this.selectedTemplateModel = this.selectedTemplateIds.map((id) =>
        this.templatelist.find((template) => template.templateId === id)
      );
    },

    selectedsite() {
      if (this.selectedsite !== "" && this.selectedpatient === "") {
        this.changesitefun();
      }
      this.getSiteBasedPatientlist();
    },

    selectedLayout() {
      if (this.selectedLayout !== "klay" && this.selectedLayout !== "dagre") {
        this.collapsedtypes = [];
      } else {
        this.collapsedtypes = [
          "Visit",
          "End Node",
          "Start Node",
          "Activity",
          "Start Activity",
          "End Activity",
          "Activity Start",
          "Activity Finish",
          "Instantiation Start",
          "Instantiation Finish",
          "Instantiation_Start",
          "Instantiation_Finish",
          "Visit Start",
          "Visit Finish",
          "Subject Status"
        ];
      }
    },

    // reflect labels/types from the left dataset for the legend
   
  },

  async mounted() {
    await this.listVersionTypes();
    this.currentstudyid = store.getters.getStudyIs;

    const graphtype = localStorage.getItem("graphType");
    // if (graphtype && graphtype !== "") this.selectedLayout = graphtype;

    this.getcolorcodes();
    this.getdefaultpatients();
    this.gettemplatedata();
    this.getVisitType();
    this.getUsers();
    this.getsites();

    if (this.currentstudyid) {
      await this.resetgraph();
    }

    window.addEventListener("studyIdChanged", async () => {
      await this.listVersionTypes();
      this.selectedpatient = "";
      this.currentstudyid = store.getters.getStudyIs;
      this.getdefaultpatients();
      this.gettemplatedata();
      this.getVisitType();
      this.getUsers();
      this.getsites();
      if (this.currentstudyid) {
        await this.resetgraph();
      }
    });
  },

  methods: {
     resetGraphReadyState() {
      this.leftGraphReady = false;
      this.rightGraphReady = false;
    },
    markGraphReady(side) {
      if (side === "left") {
        this.leftGraphReady = true;
      }
      if (side === "right") {
        this.rightGraphReady = true;
      }
    },
    releaseGraphOverlay() {
      this.leftGraphReady = true;
      this.rightGraphReady = true;
    },
     updateTypeArray() {
      if (
        this.graphidentifier !== "soa" &&
        this.graphidentifier !== "selectedpatient"
      ) {
        this.customlabel[0].Custlabel = "label";
      }
      const newnodes = this.graphdataNew && this.graphdataNew.nodes
        ? this.graphdataNew.nodes
        : [];
      const oldodes = this.graphdataOld && this.graphdataOld.nodes
        ? this.graphdataOld.nodes
        : [];
      const nodes = [...newnodes,...oldodes];
      this.typeArray = nodes
        .map((node) => {
          if (!node || !node.properties) return null;
          return node.properties.Type || node.properties.type || null;
        })
        .filter((v) => v !== null && v !== undefined);
    },
    // --- Normalize graph payloads (Color/Shapes/Type => color/shape/type; ensure link ids) ---
    normalizeGraphPayload(g) {
      if (!g || typeof g !== "object") return { nodes: [], links: [] };

      const nodes = Array.isArray(g.nodes)
        ? g.nodes.map((n) => {
            const p = n && n.properties ? n.properties : {};
            const normalized = {
              ...p,
              // color: p.color ? p.color : (p.Color ? p.Color : undefined),
              // shape: p.shape ? p.shape : (p.Shapes ? p.Shapes : undefined),
              // type: p.type ? p.type : (p.Type ? p.Type : undefined)
            };
            return { ...n, properties: normalized };
          })
        : [];

      const rawLinks = Array.isArray(g.links)
        ? g.links
        : Array.isArray(g.edges)
        ? g.edges
        : [];
      const links = rawLinks.map((e) => ({
        ...e,
        id: e.id || String(e.source) + "-" + String(e.target)
      }));

      return { ...g, nodes, links };
    },
    async validateandloadGraph(oldornew){
      console.log()
      let oldindex = this.versionList.indexOf(this.selectedVersionOld);
      let newindex = this.versionList.indexOf(this.selectedVersionNew);
      if(newindex > oldindex){
        this.compareStudyVersions();
      }
      else{
        
        alert("Invalid selection. The New Version must be later than the Old Version.");
        if(oldornew == "old"){
        this.selectedVersionOld = this.tempoldversion;
        }
        else{
        this.selectedVersionNew =  this.tempnewversion;
        }
      }
    },
    async listVersionTypes() {
      const studyId = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      const head = {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json"
        }
      };
      try {
        const res = await axios.get(
          `${this.baseurl}/management/study/studyversionlist`,
          { ...head, params: { studyId: studyId, isActive: true } }
        );
        this.versionList = res.data;

        if (Array.isArray(this.versionList) && this.versionList.length >= 2) {
          this.selectedVersionNew =
            this.versionList[this.versionList.length - 1];
          this.selectedVersionOld =
            this.versionList.length > 1
              ? this.versionList[this.versionList.length - 2]
              : this.selectedVersionNew;

          this.selectedVersion = this.selectedVersionNew;
          store.dispatch("setlatestversion", this.selectedVersionNew);
          this.noversion = false;
        }
        else{
          this.noversion = true;
        }
      } catch (err) {
        console.error("Error listing versions:", err);
      }
    },

    async compareStudyVersions() {
      this.resetGraphReadyState();
      this.spinner = true;
      try {
        // set identifier early so keys flip before data arrives
        this.graphidentifier = "compare";

        const studyId = this.currentstudyid;
        const head = {
          headers: {
            Authorization: "Bearer " + this.authToken,
            "Content-Type": "application/json"
          }
        };

        const [newRes, oldRes] = await Promise.all([
          axios.get(`${this.baseurl}/management/graph/comparednewstudyversioninfo`, {
            ...head,
            params: {
              studyId: studyId,
              oldStudyVersion: this.selectedVersionOld,
              newStudyVersion: this.selectedVersionNew
            }
          }),
          axios.get(`${this.baseurl}/management/graph/comparedoldstudyversioninfo`, {
            ...head,
            params: {
              studyId: studyId,
              oldStudyVersion: this.selectedVersionOld,
              newStudyVersion: this.selectedVersionNew
            }
          })
        ]);

        this.graphdataNew = this.normalizeGraphPayload(newRes.data) || { nodes: [], links: [] }; // left
        this.graphdataOld = this.normalizeGraphPayload(oldRes.data) || { nodes: [], links: [] }; // right
        this.updateTypeArray();
      } catch (err) {
        console.error("Error loading compare graphs:", err);
        this.releaseGraphOverlay();
      } finally {
        this.spinner = false;
      }
    },

    async getcolorcodes() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/statusmaster/getall`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        this.legendStatus = this.groupStatusByType(res.data);
        this.difflegendStatus.Visit = [
          { label: "Deleted Visit", color: "#ff4d4d" },
          { label: "New Visit", color: "#4dff88" },

        ];
        this.difflegendStatus.Activity = [
          { label: "Deleted Activity", color: "#ff4d4d" },
          { label: "New Activity", color: "#4dff88" },
        ];
        if (
          this.graphidentifier === "soa" ||
          this.graphidentifier === "visitschedule"
        ) {
          this.legendStatus.Form = [{ label: "Form", color: "#FFF3B0" }];
          this.legendStatus.Visit = [{ label: "Visit", color: "#96ffaf" }];
        }
      } catch (err) {
        console.log(err);
      }
    },

    groupStatusByType(apiResult) {
      return apiResult.reduce(function (acc, curr) {
        const statusType = curr.statusType;
        const status = curr.status;
        const colorCode = curr.colorCode;
        if (!acc[statusType]) acc[statusType] = [];
        acc[statusType].push({ label: status, color: colorCode });
        return acc;
      }, {});
    },

    changesite() {
      if (this.selectedpatient !== "") {
        this.graphidentifier = "selectedsite";
        this.selectedpatient = "";
        this.getcolorcodes();
        this.changesitefun();
      }
      this.getSiteBasedPatientlist();
    },

    // Call zoom on both panes
    zoomout() {
      if (this.$refs.graphLeft && this.$refs.graphLeft.zoomOut) {
        this.$refs.graphLeft.zoomOut();
      }
      if (this.$refs.graphRight && this.$refs.graphRight.zoomOut) {
        this.$refs.graphRight.zoomOut();
      }
    },
    zoomin() {
      if (this.$refs.graphLeft && this.$refs.graphLeft.zoomIn) {
        this.$refs.graphLeft.zoomIn();
      }
      if (this.$refs.graphRight && this.$refs.graphRight.zoomIn) {
        this.$refs.graphRight.zoomIn();
      }
    },
    layouconfigchange() {
      // Orientation is passed to the child graphs via props.
    },

    async getsites() {
      const valnow = await store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/site/getall?studyId=${valnow}&sortProperty=siteCode&IsDes=false`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        this.sites = res.data;
      } catch (err) {
        console.log(err);
      }
    },

    async gettemplatedata() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/forms/template/listtemplate?IsPrivileged=true&Status=Approved&StudyID=${store.getters.getStudyIs}&pagesize=100&SortProperty=templateName&SortOrder=0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        this.templatelist = res.data.results.sort(function (a, b) {
          return a.templateName.localeCompare(b.templateName);
        });
      } catch (err) {
        console.log(err);
      }
    },

    async popupvalidate() {
      this.popupvalidations[0] = this.popupdata.visitNo !== "";
      this.popupvalidations[1] = this.popupdata.visitName !== "";
      this.popupvalidations[2] = this.selectedTemplateIds.length > 0;
      this.popupvalidations[3] = this.popupdata.visitType !== "";
      this.popupvalidations[4] = this.popupdata.visitDate !== "";
    },

    async getUsers() {
      const valnow = await store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/study/getusersinstudy?StudyId=${valnow}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        this.users = res.data;
      } catch (err) {
        console.log(err);
      }
    },

    async addUnscheduledVisit() {
      await this.popupvalidate();
      if (this.popupvalidations.indexOf(false) !== -1) {
        this.popuperrors = this.popupvalidations;
      } else {
        this.saveUnscheduledvisit();
      }
    },

    async saveUnscheduledvisit() {
      this.popupdata.patientId = this.selectedpatient;
      this.popupdata.studyId = store.getters.getStudyIs;

      this.popupdata.forms = [];
      for (let index = 0; index < this.selectedTemplateModel.length; index++) {
        const item = this.selectedTemplateModel[index];
        this.popupdata.forms[index] = {
          template_ID: item.templateId,
          templateName: item.templateName,
          version: "1.0"
        };
      }

      const idtoken = store.getters.getIdToken;
      try {
        await axios.post(
          `${this.baseurl}/management/patientschedule/unscheduledvisit`,
          this.popupdata,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        alert(this.$t("navigations.unscheduled visit added successfully"));
        this.popupdata.visitNo = "";
        this.popupdata.visitName = "";
        this.popupdata.visitDate = "";
        this.popupdata.preVisit = "0";
        this.popupdata.postVisit = "0";
        this.popupdata.investigator = "";
        this.popupdata.IsPatientVisit = false;
        this.popupdata.forms = [];
        this.popuperrors = [];
        this.popupdata.visitType = "";
        this.selectedTemplateIds = [];
        this.popupdata.related = "";
        this.popupdata.visitNote = "";
        this.closeunscheduledvisitModal();
        this.resetgraph();
        this.modalSchedule = false;
        if (this.getShedules) this.getShedules();
      } catch (err) {
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.messages &&
          err.response.data.messages[0] &&
          err.response.data.messages[0].indexOf("Visit Number already exists") !== -1
        ) {
          alert(this.$t("navigations.visit number already exists"));
        }
      }
    },

    async getVisitType() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/visittype/listvisittypes`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        this.visitList = res.data.entities;
      } catch (err) {
        console.log(err);
        if (err && err.response && err.response.data && err.response.data.detail) {
          alert(err.response.data.detail);
        }
      }
    },

    async takesubjectid(patientid) {
      for (let i = 0; i < this.patients.length; i++) {
        const eachsubject = this.patients[i];
        if (eachsubject.patientId == patientid) {
          return eachsubject.subjectId;
        }
      }
      return null;
    },

    async closeshowChangeSchedule() {
      this.showChangeSchedule = false;
      this.graphbasedpatient();
    },

    async changevisitstatusmodel(visitinfo) {
      if (this.selectedpatient !== "") {
        this.changeStatus.studyId = this.currentstudyid;
        this.changeStatus.visitNo = visitinfo.visitNo;
        this.changeStatus.subjectId = this.selectedpatient;
        this.changeStatus.visitstatus = visitinfo.status;
        this.showChangeSchedule = true;
      }
    },

    async getdefaultpatients() {
      const currentstudy = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/patient/getpatientidbystudyid?studyId=${currentstudy}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        this.patients = res.data.results;
      } catch (err) {
        console.log(err);
      }
    },

    closeunscheduledvisitModal() {
      this.unscheduledvisitpopup = false;
    },

    openunscheduledvisitModal(currentvisit) {
      if (
        this.selectedpatient === "" ||
        this.selectedpatient === null ||
        this.selectedpatient === undefined
      ) {
        this.showSiteModal = true;
      } else {
        this.popupdata.visitNo = currentvisit.id;
        this.popupdata.related = currentvisit.id;
        this.unscheduledvisitpopup = true;
      }
    },

    async closeformModal() {
      this.setshowFormModal = false;
    },

    async showsubjectgraph(currentform) {
      if (currentform.SubjectId) {
        this.selectedpatient = currentform.SubjectId;
      }
    },

    async showsitegraph(currentform) {
      if (currentform.SiteId) {
        this.selectedpatient = "";
        this.selectedsite = currentform.SiteId;
      }
    },

    async showformmodel(currentform) {
      if (currentform.FormId) {
        this.currentform = currentform.FormId;
        this.currentformstatus = currentform.FormStatus;
        this.setshowFormModal = true;
      }
    },

    async closeModal() {
      this.showSiteModal = false;
    },

    async createGraph() {
      this.creategraphpopup = true;
    },

    async closecreategraph() {
      this.creategraphpopup = false;
    },

    async createGraphapi() {
      if (this.newgraphname === "") {
        alert("Please enter graph name");
      } else {
        const newgraphdata = { name: this.newgraphname };
        try {
          const res = await axios.post(
            `${this.baseurl}/stats-python/graph/creategraph`,
            newgraphdata,
            {
              headers: {
                Authorization: "Bearer " + this.authToken,
                "Content-Type": "application/json"
              }
            }
          );
          if (res.data && res.data._id) {
            this.selectedgraphid = res.data._id;
          }
          this.closecreategraph();
        } catch (err) {
          console.log(err);
        }
      }
    },

    async addproperties() {
      this.addpropertiespopup = true;
    },
    async cloaseaddproperties() {
      this.addpropertiespopup = false;
    },

    closedetailsModal() {
      this.detailspopup = false;
    },

    async changesitefun() {
      this.resetGraphReadyState();
      this.spinner = true;
      try {
        const graphapiresult = await axios.get(
          `${this.baseurl}/management/graph/getsiteenrollment?studyId=${this.currentstudyid}&siteId=${this.selectedsite}`,
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        );
        const normalized = this.normalizeGraphPayload(graphapiresult.data);
        this.graphdataNew = normalized;
        this.graphdataOld = normalized;
      } catch (error) {
        console.error("Error loading graph:", error);
        this.releaseGraphOverlay();
      } finally {
        this.spinner = false;
      }
    },

    async getSiteBasedPatientlist() {
      try {
        const res = await axios.get(
          `${this.baseurl}/management/patient/listpatient?SiteId=${this.selectedsite}&Studyid=${this.currentstudyid}`,
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        );
        this.patients = res.data.results;
      } catch (error) {
        console.error("Error loading patients:", error);
      }
    },

    async siteentrollementfun() {
      this.graphidentifier = "siteentrollement";
      this.getcolorcodes();
      this.resetGraphReadyState();
      this.spinner = true;
      try {
        const graphapiresult = await axios.get(
          `${this.baseurl}/management/graph/getsiteenrollment?studyId=${this.currentstudyid}`,
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        );
        const normalized = this.normalizeGraphPayload(graphapiresult.data);
        this.selectedsite = "";
        this.selectedpatient = "";
        this.graphdataNew = normalized;
        this.graphdataOld = normalized;
      } catch (error) {
        console.error("Error loading graph:", error);
        this.releaseGraphOverlay();
      } finally {
        this.spinner = false;
      }
      this.getdefaultpatients();
    },

    async graphbasedpatient() {
      this.resetGraphReadyState();
      this.spinner = true;
      try {
        const graphapiresult = await axios.get(
          `${this.baseurl}/management/graph/getpatientgraphdatabystudyid?studyId=${this.currentstudyid}&patientID=${this.selectedpatient}`,
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        );
        const normalized = this.normalizeGraphPayload(graphapiresult.data);
        this.graphdataNew = normalized;
        this.graphdataOld = normalized;
      } catch (error) {
        console.error("Error loading graph:", error);
        this.releaseGraphOverlay();
      } finally {
        this.spinner = false;
      }
    },

    async resetgraph() {
      if (
        this.selectedpatient === "" ||
        this.selectedpatient === null ||
        this.selectedpatient === undefined
      ) {
        await this.loadGraph();
      } else {
        await this.graphbasedpatient();
      }
    },

    async soagraph() {
      this.graphidentifier = "soa";
      this.getcolorcodes();
      this.selectedsite = "";
      this.selectedpatient = "";
      await this.loadGraph();
      this.getdefaultpatients();
    },

    async visitSchedulegraph() {
      this.graphidentifier = "visitschedule";
      await this.getcolorcodes();
      this.resetGraphReadyState();
      this.spinner = true;
      try {
        const graphapiresult = await axios.get(
          `${this.baseurl}/management/graph/getallgraphdatachainbystudyid?studyId=${this.currentstudyid}`,
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        );
        const normalized = this.normalizeGraphPayload(graphapiresult.data);
        this.graphdataNew = normalized;
        this.graphdataOld = normalized;
      } catch (error) {
        console.error("Error loading graph:", error);
        this.releaseGraphOverlay();
      } finally {
        this.spinner = false;
      }
      this.getdefaultpatients();
    },

    // Load compare panes
    async loadGraph() {
      if (!this.currentstudyid) return;
      if (!this.selectedVersionNew || !this.selectedVersionOld) {
        await this.listVersionTypes();
        if (!this.selectedVersionNew || !this.selectedVersionOld) return;
      }
      this.selectedVersion = this.selectedVersionNew;
      await this.compareStudyVersions();
    },

    // color validator: sync and checks a real CSS color
    isValidCssColor(str) {
      if (!str || typeof str !== "string") return false;
      const el = document.createElement("span");
      el.style.color = "";
      el.style.color = str;
      return el.style.color !== "";
    },

    // used by some dynamic expand/collapse helpers (optional)
    convertNodeLinkToCytoscape(data) {
      const elements = [];
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      if (data.nodes && data.links) {
        data.nodes.forEach((node) => {
          const expanded = node.expanded || false;
          let collapsible = node.collapsible || false;
          let color = "#0074D9";
          const p = node.properties || {};
          if (p.color && this.isValidCssColor(p.color)) {
            color = p.color;
          }
          if (uuidRegex.test(node.id)) collapsible = false;
          elements.push({
            data: {
              id: node.id,
              label: node.label || node.data || node.id,
              collapsible: collapsible,
              expanded: expanded,
              type: node.type || p.type || null,
              color: color,
              ...node
            }
          });
        });
        data.links.forEach((link) => {
          const linkId = link.id || String(link.source) + "-" + String(link.target);
          elements.push({
            data: {
              id: linkId,
              source: link.source,
              target: link.target,
              label: link.label || ""
            }
          });
        });
      } else {
        return data;
      }
      return elements;
    },

    hidePopupMenu() {
      this.showNodePopup = false;
    },

    async showproperties(selectedNode) {
      this.nodeproperties = selectedNode;
      this.detailspopup = true;
    },

    async expandNode() {
      if (!this.selectedNode) return;
      if (this.selectedNode.data("expanded")) {
        this.hidePopupMenu();
        return;
      }
      try {
        const nodeId = this.selectedNode.data("id");
        const childResponse = await axios.get(
          `${this.baseurl}/stats-python/graph/getchildnodes?graphid=${this.selectedgraphid}&childnodeid=${nodeId}`,
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        );
        if (childResponse.data.error) {
          console.error(childResponse.data.error);
          return;
        }
        let newElements = [];
        if (childResponse.data.nodes && childResponse.data.links) {
          newElements = this.convertNodeLinkToCytoscape(childResponse.data);
        } else if (!childResponse.data.links && Array.isArray(childResponse.data)) {
          const nodes = childResponse.data.map(function (childNode) {
            return {
              data: { id: childNode.id, label: childNode.label || childNode.id }
            };
          });
          const edges = childResponse.data.reduce(
            (acc, childNode) => {
              const edgeId = String(nodeId) + "-" + String(childNode.id);
              if (this.cy && this.cy.getElementById(edgeId).empty()) {
                acc.push({
                  data: {
                    id: edgeId,
                    source: nodeId,
                    target: childNode.id,
                    label: "child"
                  }
                });
              }
              return acc;
            },
            []
          );
          newElements = nodes.concat(edges);
        } else {
          newElements = this.convertNodeLinkToCytoscape(childResponse.data);
        }

        if (this.cy) {
          newElements = newElements.filter(
            (ele) => this.cy.getElementById(ele.data.id).empty()
          );
          this.cy.add(newElements);
          this.selectedNode.data("expanded", true);
          this.cy.layout(this.getLayoutConfig()).run();
        }
      } catch (error) {
        console.error("Error expanding node:", error);
      }
      this.hidePopupMenu();
    },

    collapseNode() {
      if (!this.selectedNode || !this.cy) return;

      const removeDescendants = (node) => {
        const children = node.outgoers("node");
        children.forEach((child) => {
          removeDescendants(child);
          child.remove();
        });
      };

      removeDescendants(this.selectedNode);
      this.selectedNode.data("expanded", false);
      this.cy.layout(this.getLayoutConfig()).run();
      this.hidePopupMenu();
    },

    sortAllNodes() {
      if (!this.cy || !this.rootId) {
        console.warn("Cytoscape or rootId not set yet.");
        return;
      }
      this.cy
        .layout({
          name: "breadthfirst",
          roots: [this.rootId],
          directed: false,
          fit: true,
          circle: false,
          spacingFactor: 1.2,
          padding: 30,
          sort: function (a, b) {
            const aLabel = String(a.data("label")).toLowerCase();
            const bLabel = String(b.data("label")).toLowerCase();
            const aNum = parseFloat(aLabel);
            const bNum = parseFloat(bLabel);
            if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
            return aLabel.localeCompare(bLabel);
          },
          animate: true,
          animationDuration: 500
        })
        .run();
      this.hidePopupMenu();
    },

    addArrayelements() {
      this.arrayelementspopup = true;
    },
    closeaddarrayelementspopup() {
      this.arrayelementspopup = false;
    },

    async addarrayelementapi() {
      const nodeId = this.selectedNode.data("id");
      if (this.arrayelementname === "") {
        alert("Please enter node name");
      } else {
        const newarrayelementdata = { element_name: this.arrayelementname };
        try {
          await axios.post(
            `${this.baseurl}/stats-python/graph/graphs/${this.selectedgraphid}/nodes/${nodeId}/array-elements`,
            newarrayelementdata,
            {
              headers: {
                Authorization: "Bearer " + this.authToken,
                "Content-Type": "application/json"
              }
            }
          );
          await this.loadGraph();
          await this.closeaddarrayelementspopup();
        } catch (err) {
          console.log(err);
        }
      }
    },

    addArray() {
      this.addarraypopup = true;
      this.hidePopupMenu();
    },
    closeaddarraypopup() {
      this.addarraypopup = false;
    },

    async addarrayeapi() {
      const nodeId = this.selectedNode.data("id");
      if (this.subnodearrayname === "") {
        alert("Please enter node name");
      } else {
        const newnodedata = { subnodename: this.subnodearrayname };
        try {
          await axios.post(
            `${this.baseurl}/stats-python/graph/graphs/${this.selectedgraphid}/nodes/${nodeId}/array-subnodes`,
            newnodedata,
            {
              headers: {
                Authorization: "Bearer " + this.authToken,
                "Content-Type": "application/json"
              }
            }
          );
          await this.loadGraph();
          await this.closeaddnodepopup();
        } catch (err) {
          console.log(err);
        }
      }
    },

    addSubNode() {
      this.addnodepopup = true;
      this.hidePopupMenu();
    },
    closeaddnodepopup() {
      this.addnodepopup = false;
    },

    async addsubnodeapi() {
      const nodeId = this.selectedNode.data("id");
      if (this.subnodename === "") {
        alert("Please enter node name");
      } else {
        const newnodedata = { subnodename: this.subnodename };
        try {
          await axios.post(
            `${this.baseurl}/stats-python/graph/graphs/${this.selectedgraphid}/nodes/${nodeId}/subnodes`,
            newnodedata,
            {
              headers: {
                Authorization: "Bearer " + this.authToken,
                "Content-Type": "application/json"
              }
            }
          );
          await this.loadGraph();
          await this.closeaddnodepopup();
        } catch (err) {
          console.log(err);
        }
      }
    },

    async deleteNode() {
      const nodeId = this.selectedNode.data("id");
      try {
        await axios.delete(
          `${this.baseurl}/stats-python/graph/graphs/${this.selectedgraphid}/nodes/${nodeId}`,
          {
            headers: {
              Authorization: "Bearer " + this.authToken,
              "Content-Type": "application/json"
            }
          }
        );
        await this.loadGraph();
      } catch (err) {
        console.log(err);
      }
    },

    getLayoutConfig() {
      let layoutConfig = {};
      switch (this.selectedLayout) {
        case "dagre":
          layoutConfig = {
            name: "dagre",
            rankDir: "TB",
            nodeSep: 50,
            rankSep: 100,
            edgeSep: 10,
            ranker: "longest-path",
            animate: true,
            animationDuration: 500
          };
          break;
        case "breadthfirst":
          layoutConfig = {
            name: "breadthfirst",
            roots: [this.rootId],
            directed: false,
            fit: true,
            circle: false,
            spacingFactor: 1.2,
            padding: 30,
            animate: true,
            animationDuration: 500
          };
          break;
        case "grid":
          layoutConfig = {
            name: "grid",
            rows: Math.ceil(
              Math.sqrt(this.cy ? this.cy.elements().length : 1)
            ),
            animate: true,
            animationDuration: 500
          };
          break;
        case "circle":
          layoutConfig = {
            name: "circle",
            animate: true,
            animationDuration: 500
          };
          break;
        case "cose":
          layoutConfig = {
            name: "cose",
            animate: true,
            animationDuration: 500
          };
          break;
        case "klay":
          layoutConfig = {
            name: "klay",
            nodeDimensionsIncludeLabels: true,
            fit: true,
            padding: 20,
            klay: { direction: "DOWN", spacing: 40 },
            animate: true,
            animationDuration: 500
          };
          break;
        default:
          layoutConfig = {
            name: "dagre",
            rankDir: "TB",
            nodeSep: 50,
            rankSep: 100,
            edgeSep: 10,
            ranker: "longest-path",
            animate: true,
            animationDuration: 500
          };
          break;
      }
      return layoutConfig;
    },

    applyLayout() {
      if (this.$refs.graphLeft && this.$refs.graphLeft.resetView) {
        this.$refs.graphLeft.resetView();
      }
      if (this.$refs.graphRight && this.$refs.graphRight.resetView) {
        this.$refs.graphRight.resetView();
      }
    },

    showPopup(type, event) {
      const legendItem = event.currentTarget;
      const rect = legendItem.getBoundingClientRect();
      this.popup = {
        show: true,
        type: type,
        x: rect.left + 70,
        y: rect.top + 20
      };
    },
    hidePopup() {
      this.popup.show = false;
    },

    getIconName(key) {
      const iconMap = {
        "Form node": "bottom-round-rectangle",
        "Activity node": "concave-hexagon",
        Study: "diamond",
        "Start-end": "ellipse",
        Visit: "octagon",
        Site: "Pentagon",
        Subject: "Rectangle",
        Form: "round-rectangle",
        Activity: "round-tag"
      };
      return iconMap[key];
    }
  }
};
